import { createApi } from "@reduxjs/toolkit/query/react";
import { adminBaseQueryWrapper } from "@/utils/rtkHelper";

export const DashboardApi = createApi({
    reducerPath: "DashboardApi",
    baseQuery: adminBaseQueryWrapper,
    tagTypes: ["dashboard"],
    keepUnusedDataFor: 0,
    endpoints: (builder) => ({
        getRealTimeProfitChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/dashboard/real-time-profit/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["dashboard"],
        }),
        getUpcomingProfitChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/dashboard/upcoming-profit/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["dashboard"],
        }),
        getTotalOrdersChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/dashboard/total-order-chart/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["dashboard"],
        }),
        getDropdownOptions: builder.query({
            query: () => `/dashboard/sku/sku-dropdown`,
            providesTags: ["dashboard"],
        }),
        getNetProfitChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/dashboard/net-profit/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["dashboard"],
        }),
        getReturnStatusChartChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/dashboard/return-status-chart/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["dashboard"],
        }),
        getChargeableAmtChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/dashboard/chargeable-amounts/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["dashboard"],
        }),
        getTop10SkuProfitChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/dashboard/top-10-sku-profit-chart/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["dashboard"],
        }),
        getTop10SkuLossChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/dashboard/top-10-sku-loss-chart/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["dashboard"],
        }),
        getTop10SalesSkuChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/dashboard/top-10-sales-sku/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["dashboard"],
        }),
        getTop10CityWiseSalesOrderChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/dashboard/top-10-sales-order-city-wise/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["dashboard"],
        }),
        getTop10StateWiseSalesOrderChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/dashboard/top-10-sales-order-state-wise/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["dashboard"],
        }),
        getTop10SkuOfCustomerReturnChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/dashboard/top-10-sku-of-customer-return/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["dashboard"],
        }),
        getTop10CustomerReturnChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/dashboard/top-10-customer-return/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["dashboard"],
        }),
        getTop10StateWiseCustomerReturnChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/dashboard/top-10-customer-returns-state/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["dashboard"],
        }),
        getDashboardCounts: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/dashboard/dashboard-count/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["dashboard"],
        }),
    }),

})

export const {
    useGetRealTimeProfitChartQuery,
    useGetUpcomingProfitChartQuery,
    useGetTotalOrdersChartQuery,
    useGetDropdownOptionsQuery,
    useGetNetProfitChartQuery,
    useGetReturnStatusChartChartQuery,
    useGetChargeableAmtChartQuery,
    useGetTop10SkuProfitChartQuery,
    useGetTop10SkuLossChartQuery,
    useGetTop10SalesSkuChartQuery,
    useGetTop10SkuOfCustomerReturnChartQuery,
    useGetTop10CityWiseSalesOrderChartQuery,
    useGetTop10StateWiseSalesOrderChartQuery,
    useGetTop10CustomerReturnChartQuery,
    useGetTop10StateWiseCustomerReturnChartQuery,
    useGetDashboardCountsQuery
} = DashboardApi;
